<template lang="pug">
.date-compare
    .q-timespan
        .timespan(
            @click="setBaseDate(0)",
            :class="{ active: !useCompare && this.dateName === 'today' }"
        ) 今天
        .timespan(
            @click="setBaseDate(-1)",
            :class="{ active: !useCompare && this.dateName === 'yestoday' }"
        ) 昨天
        v-date-picker(v-model="baseDate", :max-date="today", :min-date="yearAgo2")
        v-checkbox(v-model="useCompare", title="对比")
        v-date-picker(v-model="comparedDate", :disabled="!useCompare", :min-date="yearAgo", :max-date="today", ref="comparedPicker")
    
    v-radio-group(
        v-show="!useCompare",
        name="date-compare",
        v-model="compareType",
        :options="compareTypeOption",
        class="compare-type"
    )
    
</template>

<script>
import { getDateString, datePlus } from '../script/util.js';

export default {
    props: {
        value: {
            type: Array,
            required: true
        }
    },
    data() {
        let today = getDateString.today();
        let yestoday = getDateString.yestoday();
        let date1 = new Date();
        let date2 = new Date();
        date1.setFullYear(date1.getFullYear() - 1);
        date2.setFullYear(date2.getFullYear() - 1);
        date2.setDate(date2.getDate() + 1);
        return {
            today,
            yestoday,
            yearAgo:  getDateString(date1),
            yearAgo2: getDateString(date2),
            baseDate: this.value[0],
            dateName: 'today',
            useCompare: false,
            comparedDate: this.value[1],
            compareTypeOption: [{
                value: -1,
                title: '日环比'
            }, {
                value: -7,
                title: '周同比'
            }],
            compareType: -1
        };
    },
    computed: {
        result() {
            let base = this.baseDate;
            let compared = '';

            if (this.useCompare) {
                compared = this.comparedDate;
            } else {
                compared = datePlus(base, Number(this.compareType));
            }

            return [base, compared];
        }
    },
    watch: {
        useCompare(newVal) {
            if (newVal) {
                this.comparedDate = datePlus(this.baseDate, -1);
                this.$refs.comparedPicker.showCalendar = true;
            }
        },
        baseDate(newVal) {
            if (newVal === this.yestoday) {
                this.dateName = 'yestoday';
            } else if (newVal === this.today) {
                this.dateName = 'today';
            } else {
                this.dateName = newVal;
            }
        },
        result(newVal, oldVal) {
            this.$emit('input', newVal);
        }
    },
    methods: {
        setBaseDate(increment) {
            this.baseDate = datePlus(new Date(), increment);
            this.useCompare = false;
        }
    }
};
</script>

<style scoped>
@import '../css/base/variables.css';

.date-compare {
    -webkit-user-select: none;
            user-select: none;
}

.q-timespan {
    margin: 15px 0;
    display: inline-block;
}

.timespan {
    display: inline-block;
    margin-right: 12px;
    padding: 0 5px;
    cursor: pointer;
    &.active {
        color: var(--white-color);
        background-color: var(--primary-color);
    }
}

.datepicker {
    display: inline-block;
}
</style>

<style>
.date-compare > .q-timespan {
    margin-right: 15px;
}
/*.date-compare .calendar {
    z-index: 99999;
    font-size: 14px;
}*/
.date-compare .checkbox {
    margin: 0 5px;

    label i {
        margin-right: 4px;
    }
}
.date-compare .datepicker input[disabled] {
    border: 1px solid #e9e9e9;
    background-color: #f1f1f1;
    color: #ccc;
    cursor: not-allowed;
    color: transparent;
}
.date-compare .compare-type {
    display: inline-block;
    & > label {
        margin-right: 10px;
        margin-left: 0;
    }
}
</style>



// WEBPACK FOOTER //
// date-compare.vue?1adef59a